/* global G */
import { curry } from 'lib/util'

/**
 * Shows the "Coming soon" dialog.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>} void
 */
// eslint-disable-next-line no-unused-vars
const soon = async (module, component, event) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]

  eventBus.dispatch(eventBus.type(G.DATA, G.UNDO), {
    title: module[G.ADAPTER][G.INTL]._t(
      'dialog.soon.title',
      {
        ns: 'common',
        _key: 'dialog.soon.title',
        defaultValue: 'Coming soon',
      },
    ),
    text: module[G.ADAPTER][G.INTL]._t(
      'dialog.soon.text',
      {
        ns: 'common',
        _key: 'dialog.soon.text',
        defaultValue: 'This feature is under development.',
      },
    ),
    children: {
      ok: {
        key: 'ok',
        value: module[G.ADAPTER][G.INTL]._t(
          'button.ok',
          {
            ns: 'common',
            _key: 'button.ok',
            defaultValue: 'Ok',
          },
        ),
      },
    },
  })
}
export default curry(soon)
